import * as XLSX from 'xlsx'

// Excel forbids these characters in a worksheet/tab name and caps the name at 31 chars
const INVALID_SHEET_CHARS = /[\\/?*[\]:]/g

// Coerce a desired tab title into a name Excel will accept: strip illegal
// characters, trim to 31 characters, and fall back to a placeholder if empty
const sanitizeSheetName = (name, index) => {
  const cleaned = String(name == null ? '' : name)
    .replace(INVALID_SHEET_CHARS, ' ')
    .trim()
    .slice(0, 31)
  return cleaned || `Sheet ${index + 1}`
}

// Excel also requires every tab name to be unique; append " (2)", " (3)", ...
// to any collision while keeping the result within the 31 character limit
const ensureUniqueName = (name, used) => {
  if (!used.has(name)) {
    used.add(name)
    return name
  }
  let suffix = 2
  let candidate = ''
  do {
    const tail = ` (${suffix})`
    candidate = name.slice(0, 31 - tail.length) + tail
    suffix += 1
  } while (used.has(candidate))
  used.add(candidate)
  return candidate
}

// Build and trigger download of a multi-tab .xlsx file in the browser.
// sheets is an ordered array of { name, aoa, merges?, cols? }; tab order
// matches array order. aoa is the full array of cell-arrays (header rows
// included). Optional merges is an array of { s:{r,c}, e:{r,c} } ranges and
// cols is an array of { wch } column widths. Freeze panes and cell coloring
// are intentionally omitted: the community SheetJS writer does not emit them.
export const downloadWorkbook = (sheets, fileName) => {
  const workbook = XLSX.utils.book_new()
  const usedNames = new Set()

  sheets.forEach((sheet, index) => {
    const worksheet = XLSX.utils.aoa_to_sheet(sheet.aoa || [])
    if (sheet.merges) worksheet['!merges'] = sheet.merges
    if (sheet.cols) worksheet['!cols'] = sheet.cols
    const name = ensureUniqueName(sanitizeSheetName(sheet.name, index), usedNames)
    XLSX.utils.book_append_sheet(workbook, worksheet, name)
  })

  XLSX.writeFile(workbook, fileName)
}
